import gql from 'graphql-tag'

export const ADD_VALUATION = gql`
  mutation avaliaConteudo(
    $tipo: String!,
    $modulo_id: String!,
    $conteudo_id: String!,
    $trilha_id: String!,
    $curso_id: String!) {
    avaliaConteudo(
      tipo: $tipo
      modulo_id: $modulo_id
      conteudo_id: $conteudo_id
      trilha_id: $trilha_id
      curso_id: $curso_id
      ) {
      _id
      curso_id
      modulo_id
      conteudo_id
      trilha_id
      createdAt
      updatedAt
    }
  }
`

export const ADD_ANSWER_RESEARCH = gql`
mutation adicionaRespostasPesquisa(
  $pesquisas_disparo_id: String!, 
  $curso_id: String,
  $respostas: [RespostaRespostasPesquisasInput]
  ) {
      adicionaRespostasPesquisas(
        pesquisas_disparo_id: $pesquisas_disparo_id
        curso_id: $curso_id
        respostas: $respostas
        ) {
       usuario_id,
       pesquisas_disparo_id,
       respostas {
         alternativa
         descricao
         pergunta_pesquisa_id
       }
      }
     }
   
        
`

export const ADD_COMMENT = gql`
  mutation comentaConteudo(
    $descricao: String!,
    $modulo_id: String!,
    $conteudo_id: String!,
    $trilha_id: String!,
    $curso_id: String!) {
    comentaConteudo(
      descricao: $descricao
      modulo_id: $modulo_id
      conteudo_id: $conteudo_id
      trilha_id: $trilha_id
      curso_id: $curso_id
      ) {
      _id
      descricao
      createdAt
    }
  }
`